import { z } from 'zod';
/**
 * The merchant (ADR 0016). The client names what it sells and how many; the
 * server knows the price, where the player stands, and pays.
 */
export const SellItemMessageSchema = z.object({
    itemId: z.uuid(),
    quantity: z.number().int().min(1).max(99),
});
/** To the seller alone, after the sale; the new inventory, gold included, follows. */
export const SellResultSchema = z.object({
    templateId: z.string().min(1),
    quantity: z.number().int().min(1),
    gold: z.number().int().min(0),
});
export const SELL_REFUSALS = [
    'invalid',
    'unknown-item',
    'worthless',
    'quantity',
    'too-far',
    /** The camp's merchant keeps out of a lesson's pieces (ADR 0078). */
    'kept',
];
export const SellRejectedSchema = z.object({ reason: z.enum(SELL_REFUSALS) });
export const BuyItemMessageSchema = z.object({
    templateId: z.string().min(1).max(64),
    quantity: z.number().int().min(1).max(99),
});
/** To the buyer alone, after the purchase; the new inventory, gold included, follows. */
export const BuyResultSchema = z.object({
    templateId: z.string().min(1),
    quantity: z.number().int().min(1),
    gold: z.number().int().min(0),
});
export const BUY_REFUSALS = ['invalid', 'not-sold', 'missing-gold', 'bag-full', 'too-far'];
export const BuyRejectedSchema = z.object({ reason: z.enum(BUY_REFUSALS) });
//# sourceMappingURL=merchant.js.map